export default class BraintreeService {
  configure = config =>
    new Promise((resolve, reject) => {
      braintree.client.create(
        { authorization: config.authorization },
        (error, clientInstance) => {
          this.braintreeClient = clientInstance;

          Promise.all([
            this.createHostedFields(config.hostedFields, config.hostedFieldsEventHandlerFactory),
            this.createVault(config.enableVault),
            this.createThreeDSecure(config.enableThreeDSecure),
            this.createDataCollector(),
          ]).then(components => {
            this.braintreeHostedFields = components[0];
            this.braintreeVault = components[1];
            this.braintreeThreeDSecure = components[2];
            this.braintreeDataCollector = components[3];
            resolve(this);
          })
        }
      )
    });

  createDataCollector = () => braintree.dataCollector.create({ client: this.braintreeClient })

  createHostedFields = (hostedFieldsConfig, hostedFieldsEventHandlerFactory) =>
    new Promise((resolve, reject) => {
      braintree.hostedFields.create({
        client: this.braintreeClient,
        styles: {
          "input": {
            "font-family": "Circular, Helvetica, Arial, sans-serif",
            "font-size": "20px",
            "line-height": "40px",
            "color": "#222"
          }
        },
        fields: hostedFieldsConfig
      }, (_error, hostedFieldsInstance) => {
        const handler = hostedFieldsEventHandlerFactory(hostedFieldsInstance)
        hostedFieldsInstance.on("validityChange", handler);
        hostedFieldsInstance.on("blur", handler);
        resolve(hostedFieldsInstance);
      });
    });

  createVault = isEnabled =>
    new Promise((resolve, reject) => {
      if (!isEnabled) { return resolve(null); }

      braintree.vaultManager.create(
        { client: this.braintreeClient },
        (_error, vaultManagerInstance) => resolve(vaultManagerInstance)
      );
    });

  createThreeDSecure = isEnabled =>
    new Promise((resolve, reject) => {
      if (!isEnabled) { return resolve(null); }

      braintree.threeDSecure.create(
        { client: this.braintreeClient, version: 2 },
        (error, threeDSecureInstance) => resolve(threeDSecureInstance)
      );
    });

  fetchSavedPaymentMethods = () =>
    new Promise((resolve, reject) => {
      if (!this.braintreeVault) {
        return resolve([]);
      }

      this.braintreeVault.fetchPaymentMethods(
        (error, paymentMethods) => resolve(paymentMethods)
      );
    });
};
